module.exports = __webpack_public_path__ + "static/media/5_of_clubs.de23df17.png";